
/* injects from baggage-loader */

'use strict';

import AccountBankAccountsComponent from './account.bank-accounts.component';

const AccountBankAccountsPageModule = angular.module('account-bank-accounts-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.bank-accounts', {
        url: '/bank-accounts',
        component: 'accountBankAccounts',
        // Requires valid login to visit
        protected: true,
        // Resolve promises into controller bindings, see component for bindings
        resolve: { 
          stripeAccount: function(Parse) {
            return Parse.Cloud.run('fetchStripeCustomer');
          }
        }
      });
  })
  .component('accountBankAccounts', new AccountBankAccountsComponent());

export default AccountBankAccountsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/bank-accounts/account.bank-accounts.module.js